import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  LoanDto,
  CardResponseDto,
  AccountDto,
  CustomerCollectionCompanyHistoryDto,
  CalculateNewLimitResponseDto,
  AutoIssueCheckResponseDto
} from "@src/api-new/generated-api.schemas";

interface DashboardState {
  customerAccounts: AccountDto[],
  cards: CardResponseDto[],
  arrangedDbtLoanIds: number[],
  lastLoanStatus?: string,
  allLoans?: LoanDto[],
  activeLoans?: LoanDto[],
  showCancelTransferButton: boolean,
  overdueLoans?: LoanDto[],
  isLoading: boolean,
  showAdditionalPhoneButton: boolean;
  collectionCompanyInfo?: CustomerCollectionCompanyHistoryDto;
  ocrCheckResult?: any;
  calculatedLimit?: CalculateNewLimitResponseDto;
  autoIssueCheckResult?: AutoIssueCheckResponseDto;
}

const initialState: DashboardState = {
  isLoading: true,
  customerAccounts: [],
  cards: [],
  arrangedDbtLoanIds: [],
  showCancelTransferButton: false,
  showAdditionalPhoneButton: true
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setUserLastLoanStatus(state, action: PayloadAction<string>) {
      state.lastLoanStatus = action.payload;
    },
    getCustomerAccounts(state, action: PayloadAction<AccountDto[]>) {
      state.customerAccounts = action.payload;
    },
    getCards(state, action: PayloadAction<CardResponseDto[]>) {
      state.cards = action.payload;
    },
    getAllLoans(state, action: PayloadAction<LoanDto[]>) {
      state.allLoans = action.payload;
    },
    getActiveLoans(state, action: PayloadAction<LoanDto[]>) {
      state.activeLoans = action.payload;
    },
    getOverdueLoans(state, action: PayloadAction<LoanDto[]>) {
      state.overdueLoans = action.payload;
    },
    getArrangedDbtLoan(state, action: PayloadAction<number[]>) {
      state.arrangedDbtLoanIds = action.payload;
    },
    getAutoIssueCheckResult(state, action: PayloadAction<AutoIssueCheckResponseDto>) {
      state.autoIssueCheckResult = action.payload;
    },
    updateCancelTransferStatus(state, action: PayloadAction<boolean>) {
      state.showCancelTransferButton = action.payload;
    },
    showAdditionalPhoneButton(state, action: PayloadAction<boolean>) {
      state.showAdditionalPhoneButton = action.payload;
    },
    getCollectionCompanyInfo(
      state,
      action: PayloadAction<CustomerCollectionCompanyHistoryDto>
    ) {
      state.collectionCompanyInfo = action.payload;
    },
    getOcrAutoCheckResult(state, action: PayloadAction<any>) {
      state.ocrCheckResult = action.payload;
    },
    calculateLimit(state, action: PayloadAction<CalculateNewLimitResponseDto>) {
      state.calculatedLimit = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    cancelTransfer(state, action: PayloadAction<LoanDto>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default dashboardSlice.reducer;
export const {
  setUserLastLoanStatus,
  getCustomerAccounts,
  getCards,
  getAllLoans,
  getActiveLoans,
  getOverdueLoans,
  getArrangedDbtLoan,
  getAutoIssueCheckResult,
  updateCancelTransferStatus,
  showAdditionalPhoneButton,
  getCollectionCompanyInfo,
  getOcrAutoCheckResult,
  calculateLimit,
  setIsLoading,
  cancelTransfer,
  destroy
} = dashboardSlice.actions;
export const dashboardActions = dashboardSlice.actions;
